<div class="justify-center m-auto">
  <div class="card fluid">
    <div class="card__content border-bottom border-gray-600">
      <div class="width-full text-center">
        <div class="font-24 success-green bold mb-20 mt-10">
          <span class="icon-container">
            <i class="fas fa-check"></i>
          </span>
          Success!
        </div>
        @if (message) {
          <div class="mb-20">
            {{ message }}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="mt-20">
    <div class="container flex mobile justify-center">
      <button class="rounded-4 hover-blue-800 black mobile mr-20">
        <a class="btn-txt font-white bold" [routerLink]="['..']">
          Take me back to the home page
        </a>
      </button>
    </div>
  </div>
</div>